import React from 'react';
import { motion } from 'framer-motion';
import { Scale } from 'lucide-react';
export function CostoOportunidad() {
  const rows = [{
    sin: 'Llamadas de acoso sin saber cómo responder',
    costo: 'Estrés permanente + errores que reinician plazos'
  }, {
    sin: 'Registros que podrían haber caducado hace años',
    costo: 'Años extra de exclusión financiera innecesaria'
  }, {
    sin: 'Pagar montos completos sin negociar',
    costo: '50-80% más de lo necesario en muchos casos'
  }, {
    sin: 'Sin protocolo ante estudios jurídicos',
    costo: 'Promesas que reactivan plazos de prescripción'
  }, {
    sin: 'Sin conocer el Derecho al Olvido',
    costo: 'Registros que el sistema ya debería haber eliminado'
  }, {
    sin: 'La misma angustia el año que viene',
    costo: 'El ciclo que no se rompe sin información'
  }];
  return <section className="py-12 md:py-20 px-4 bg-brand-dark" data-id="element-73">
      <div className="max-w-4xl mx-auto" data-id="element-74">
        <div className="text-center mb-12" data-id="element-75">
          <Scale className="w-12 h-12 text-gold mx-auto mb-4" data-id="element-76" />
          <h2 className="text-3xl font-black text-white" data-id="element-77">
            ¿Cuánto Cuesta No Tenerlo?
          </h2>
        </div>

        <div className="bg-brand-green border border-gold/20 rounded-2xl overflow-hidden mb-12" data-id="element-78">
          <div className="hidden md:grid grid-cols-2 bg-brand-dark border-b border-gold/20 p-4" data-id="element-79">
            <div className="font-bold text-cream" data-id="element-80">
              Sin Sistema Libre de Clearing
            </div>
            <div className="font-bold text-red-400" data-id="element-81">Costo Real</div>
          </div>

          <div className="divide-y divide-gold/10" data-id="element-82">
            {rows.map((row, i) => <div key={i} className="p-4 md:grid md:grid-cols-2 gap-4 items-center hover:bg-brand-light/50 transition-colors" data-id="element-83">
                <div className="text-cream/90 text-sm mb-2 md:mb-0" data-id="element-84">
                  <span className="md:hidden font-bold text-gold text-xs uppercase tracking-wider block mb-1" data-id="element-85">
                    Situación:
                  </span>
                  {row.sin}
                </div>
                <div className="text-red-300 text-sm font-medium" data-id="element-86">
                  <span className="md:hidden font-bold text-red-500 text-xs uppercase tracking-wider block mb-1" data-id="element-87">
                    Costo:
                  </span>
                  {row.costo}
                </div>
              </div>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-88">
          <p className="text-2xl md:text-3xl font-black text-gold-gradient italic" data-id="element-89">
            "La próxima semana puede ser diferente." 🇺🇾
          </p>
        </motion.div>
      </div>
    </section>;
}